import React, { useEffect, useState } from "react";

// import "antd/dist/antd.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";

import { FaTrash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";

import { Box } from "@chakra-ui/react";
import { currencyFormate } from "jsFunctions/helperFunctions";
import calculateTds from "jsFunctions/calculateTds";
import DrawerButton from "./component/buttons/drawerButton";

const TdsExpense = ({
  getData,
  autoCount,
  editData,
  deleteMultipleTdsItem,
  tdsData,
  remainingTds,
  tdsAmountError,
  expenseType,
  isEdit,
  role,
  isTDSPoGenerated
}) => {
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);

  const [amountTotal, setAmountTotal] = useState("");
  const [tdsPercent, setTdsPercent] = useState("");
  const [editPercentNum, setEditPercentNum] = useState(true);
  const [tdsAmount, setTdsAmount] = useState(0);

  const handleEditTDSPercentange = () => {
    setEditPercentNum(false);
  };
 

  const onChangeValues = (totalValue, percentValue, tdsValue) => {
    const data = {
      bsAmt:totalValue,
      prc:percentValue,
      tlAmt:tdsValue
    };
    getData(data);
  };

  useEffect(()=>{
    if(tdsData){
      if(tdsData?.bsAmt){
        setAmountTotal(tdsData?.bsAmt);
      }
        setTdsPercent(tdsData?.prc);
        setTdsAmount(tdsData?.tlAmt)
    }
   
  },[tdsData])

  const setDefaultTaxableAmount = ()=>{
    if(!tdsData?._id){
      setAmountTotal(remainingTds)
      setTdsPercent(tdsData?.prc || 10);
      const tdsAmt = calculateTds(remainingTds,10)
      setTdsAmount(tdsAmt);
      onChangeValues(remainingTds,10,tdsAmt)
    }
    else{
      const tdsObj = editData?.tdsApl?.list.find(item=> item?._id === tdsData?._id)
      if(tdsObj){
        setAmountTotal(tdsObj?.bsAmt);
        setTdsPercent(tdsObj?.prc)
        setTdsAmount(tdsData?.tlAmt)
        onChangeValues(tdsObj?.bsAmt,tdsObj?.prc,tdsData?.tlAmt)
      }
    }
  }
  useEffect(()=>{
    if(tdsData && !tdsData?.bsAmt){
      setDefaultTaxableAmount()
    }
  },[remainingTds])
  return (
    <div
      className={`payment-listing_box ${addTogglePaymentIdx ? "show" : "hide"}`}
    >
      <div className="payment-list_array">
        <div className="d-flex">
          <span className="payment-details">TDS Details {autoCount + 1}</span>
          <span className="amountSpan">
            { amountTotal ? currencyFormate(Number(amountTotal)) :0 }
          </span>
        </div>
        
        <div className="d-flex toggleImage-content">
        {["Admin", "Manager", "Accountant"].includes(role) && (
          <div className="d-flex mx-3">
            <span>
              <FaTrash
                style={{
                  fontSize: "16px",
                  color: "red",
                  cursor: "pointer",
                }}
                className={isTDSPoGenerated() ? 'is-disable-delete' : ''}
                onClick={()=>{
                  if(!isTDSPoGenerated()){

                    deleteMultipleTdsItem()
                  }
                }
                }
                disabled={isTDSPoGenerated()}
              />
            </span>
          </div>
        )}
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
       
      </div>
      <div
        className={`payment-inner_box mb-4 ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>Total Amount</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <span className="rupee-symbol">₹</span>{" "}
                </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                  placeholder="Total Amount "
                  onValueChange={(e) => {
                    onChangeValues(
                      e.value,
                      tdsPercent,
                      tdsAmount
                    );
                    setAmountTotal(e.value);
                  }}
                  onBlur={() => {
                    if (!amountTotal) {
                      setDefaultTaxableAmount();
                    }
                  }}
                  disabled={isTDSPoGenerated()}
                  name="Total Amount "
                  value={amountTotal || ""}
                  thousandSeparator={true}
                  // prefix={"$"}

                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </InputGroup>
            </Box>
            {
            <p className="form_error"> {tdsAmountError[`tds.${autoCount}.amountTotal`]}</p>
            }
          </Col>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>TDS Percent</Form.Label>
              <InputGroup className="input-group">
                <Form.Control
                  type="number"
                  placeholder="TDS Percent"
                  value={tdsPercent}
                  disabled={editPercentNum}
                  onChange={(e) => {
                    onChangeValues(
                      amountTotal,
                      e.target.value,
                      tdsAmount
                    );
                    setTdsPercent(e.target.value);
                  }}
                />

                <InputGroup.Text>
                  {editPercentNum && !isTDSPoGenerated() ? (
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                      alt="edit"
                      className="edit-button"
                      onClick={handleEditTDSPercentange}
                    />
                  ) : (
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                      alt="edit"
                      className="edit-button"
                      onClick={() => setEditPercentNum(true)}
                    />
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Box>
          </Col>
        </Row>
        <Row>
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>TDS Amount</Form.Label>

              <InputGroup>
                <InputGroup.Text>
                  <span className="rupee-symbol">₹</span>{" "}
                </InputGroup.Text>
                <CurrencyFormat
                  customInput={Form.Control}
                  type="text"
                 
                  name="TDS Amount "
                  value={
                    tdsAmount
                      ? Number(tdsAmount).toFixed(2)
                      : Number(0).toFixed(2)
                  }
                  disabled
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />

               
              </InputGroup>
            </Box>
          </Col>
          <Col></Col>
        </Row>
      </div>
    </div>
  );
};

export default TdsExpense;
